import { Auth, Connect, Message, SocketObservable } from '@genesislcap/foundation-comms';
import { observable } from '@microsoft/fast-element';
import { DI } from '@microsoft/fast-foundation';
import { updateArray } from '../utils/dataserver';

export interface IExecutionNotification {
  USER_NAME: string;
  NEGOTIATION_ID: string;
  CASCADE_COMPANY_ID: string;
  EXECUTION_NOTIFICATION_TYPE: string;
  NEGOTIATION_STATUS: string;
}

export enum EXECUTION_NOTIFICATION_TYPE {
  RFQ = 'RFQ',
  AUTO_EXECUTE = 'AUTO_EXECUTE',
}

export interface IExecutionService {
  executionNotifications: IExecutionNotification[];
  getExecutionNotifications(): SocketObservable<Message>;
  deleteExecutionNotification(notificationId): Promise<any>;
  startStreaming(): void;
  setNegotiationId(string): void;
  getNegotiationId(): string
}

class ExecutionServiceImpl implements IExecutionService {
  @observable public executionNotifications: IExecutionNotification[] = [];

  constructor(@Connect private connect: Connect, @Auth private auth: Auth) {}

  private negotiationId: string = null

  setNegotiationId(negotiationId: string) {
    this.negotiationId = negotiationId;
  }
  getNegotiationId() {
    return this.negotiationId;
  }

  startStreaming() {
    this.getExecutionNotifications().subscribe({
      next: (streamMessage: Message) => {
        const resultList = streamMessage.ROW ?? null;
        if (resultList) {
          let executionNotificationsAux = [...this.executionNotifications];
          this.executionNotifications = updateArray(resultList, executionNotificationsAux);
        }
      },
      error: (error: any) => {},
    });
  }

  getExecutionNotifications(): SocketObservable<Message<any>> {
    const request: any = this.connect.stream(
      'EXECUTION_NEGOTIATION',
      (streamMessage: Message) => {
        () => {};
      },
      (x) => {}
    );

    return request;
  }

  async deleteExecutionNotification(negotiationId: any): Promise<any> {
    const executionNotification = {
      NEGOTIATION_ID: negotiationId,
    };
    const request: any = await this.connect.commitEvent(
      'EVENT_NEGOTIATION_NOTIFICATION_VIEW_REDUCTION',
      {
        DETAILS: executionNotification,
        IGNORE_WARNINGS: true,
        VALIDATE: false,
      }
    );
    return request;
  }
}

export const IExecutionService = DI.createInterface<IExecutionService>(
  (x) => x.singleton(ExecutionServiceImpl)
);
